var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticStyle:{"display":"flex","align-self":"center"}},[_c('hollow-dots-spinner',{attrs:{"animation-duration":2000,"size":60,"dot-size":16,"dots-num":3,"color":"black"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }